import { SaveAlt, Search } from "@material-ui/icons";
import { Box, Fab, Grid, Tooltip } from "@mui/material";
import DateRangePicker from "components/date-picker/DateRangePicker";
import Select from "components/select/Select";
import { BUSINESS_REPORT_OPTIONS } from "constant";
import { useFormik } from "formik";
import { getDateRangePickerFieldProps, getSelectFieldProps } from "ultis/form";

const ReportBusinessFilter = ({ onSubmit, onExport, isDisabledExport }) => {
  const defaultFrom = new Date();
  defaultFrom.setHours(0, 0, 0, 0);
  const defaultTo = new Date(defaultFrom);
  defaultTo.setHours(23, 59, 59, 999);

  const formik = useFormik({
    initialValues: {
      typeReport: BUSINESS_REPORT_OPTIONS[1].value,
      dateRange: [defaultFrom, defaultTo],
    },
    onSubmit,
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <Box sx={{ p: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <Select
              {...getSelectFieldProps(formik, "typeReport")}
              label="Loại báo cáo kinh doanh"
              options={BUSINESS_REPORT_OPTIONS?.map((item) => ({
                value: item.value,
                label: item.label,
              }))}
            />
          </Grid>

          <Grid item xs={6}>
            <DateRangePicker
              {...getDateRangePickerFieldProps(formik, "dateRange")}
              isTime
              startDateLabel="Thời gian gọi từ"
              endDateLabel="Thời gian gọi đến"
            />
          </Grid>

          <Grid item xs={3}>
            <Tooltip title="Tìm kiếm" disableFocusListener>
              <Fab color="primary" aria-label="Search" type="submit">
                <Search />
              </Fab>
            </Tooltip>
            <Tooltip title="Tải báo cáo" disableFocusListener>
              <Fab
                color="primary"
                sx={{ ml: 1 }}
                aria-label="Search"
                onClick={onExport}
                disabled={isDisabledExport}>
                <SaveAlt />
              </Fab>
            </Tooltip>
          </Grid>
        </Grid>
      </Box>
    </form>
  );
};

export default ReportBusinessFilter;
